<template>
  <ZigzagServiceLayout
    mainTitle="Ear OtoModeling & Earlobe Rejuvenation"
    mainDescription="At Diverse Care Now, we offer minimally invasive procedures designed to reshape, rejuvenate, and restore your ears — without the need for traditional surgery. Minimal downtime with professional care."
    :sections="sections"
  />
</template>

<script>
import ZigzagServiceLayout from '../../../components/ZigzagServiceLayout.vue';

export default {
  name: 'EarLobeRepairContentEn',
  components: {
    ZigzagServiceLayout,
  },
  data() {
    return {
      sections: [
        {
          label: 'OTOMODELING',
          title: 'Ear OtoModeling (Incisionless Ear Reshaping)',
          subtitle: 'Reshape and reposition prominent ears without extensive surgery.',
          paragraphs: [
            "OtoModeling is a minimally invasive procedure designed to reshape and reposition prominent ears without the need for extensive surgery. The procedure is performed using internal permanent sutures that reshape the ear cartilage and create a more natural contour while preserving the ear's anatomy.",
            "The procedure is performed in the office under local anesthesia, allowing patients to remain awake and comfortable throughout treatment. Because no large incisions are required, recovery is typically faster than with traditional otoplasty, with less swelling and minimal downtime."
          ],
          list: [
            "Minimally invasive technique",
            "Performed under local anesthesia",
            "Internal permanent sutures to reshape the ear",
            "No general anesthesia required",
            "Minimal scarring",
            "Short recovery time",
            "Natural-looking results"
          ],
          videoEmbeds: [
            'https://www.youtube.com/embed/9rbA47bOvms'
          ]
        },
        {
          label: 'REJUVENATION',
          title: 'Earlobe Rejuvenation with Dermal Fillers',
          subtitle: 'Restore volume and youthful appearance to aging earlobes.',
          paragraphs: [
            "As we age, the earlobes naturally lose collagen, elastin, and fat, causing them to appear thinner, deflated, or elongated. This volume loss can also result from years of wearing heavy earrings.",
            "At Diverse Care Now, we use hyaluronic acid dermal fillers to restore lost volume, improve contour, and rejuvenate the appearance of the earlobes. The treatment creates a fuller, smoother, and more youthful look while providing better support for earrings."
          ],
          list: [
            "Restores age-related volume loss",
            "Improves the shape and contour of the earlobes",
            "Creates a more youthful appearance",
            "Provides better support for earrings",
            "Quick, minimally invasive office procedure"
          ],
          image: '/images/services/earlobe-repair.png'
        }
      ]
    };
  }
};
</script>
